export default function mergeStates(base, updates) {
  const merged = { ...base };
  for (const key in updates) {
    if (updates.hasOwnProperty(key)) {
      if (typeof updates[key] === 'object' && !Array.isArray(updates[key])) {
        merged[key] = mergeStates(base[key] || {}, updates[key]);
      } else {
        if (key !== 'meeting') merged[key] = updates[key];
      }
    }
  }
  return merged;
}
